import { Accordion, AccordionItem, AccordionHeading, AccordionPanel } from "@reusable";
import * as React from 'react';
export default {
  Accordion,
  AccordionItem,
  AccordionHeading,
  AccordionPanel,
  React
};